
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from "@angular/router";
import { physicalTherapySessionComponent } from './physical-therapy-session.component';

const Route: Routes = [
  {
    path: '', children: [
   
      { path: 'session-detail', component: physicalTherapySessionComponent },
      
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(Route)
   

  ],
  declarations: [
    
  ],
  exports: [

    RouterModule

  ]
})
export class physicalTherapySessionRoutingModule { }
